import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Loading from "../../components/Loading";
import {
  Container,
  Button,
  Box,
  Typography,
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import VolverButton from "../../components/VolverButton";
import { EventoVouchers } from "./tarifas/EventoVouchers";
import { EventoTickets } from "./tarifas/EventoTickets";
import withAuthenticationRequired from "../../components/ProtectedRoutes/withAuthenticationRequired";
import CreateEditTarifa from "../../components/modales/tarifas/CreateTarifa";
import { api } from "../../services/api";
import { toast } from "react-toastify";
import useGetFechasEvento from "../../hooks/useGetFechasEvento";
import moment from 'moment-timezone';

export const Tarifas = () => {
  const param = useParams();
  const [t] = useTranslation("global");
  const [modalOpen, setModalOpen] = useState(false);
  const [tipoSeleccionado, setTipoSeleccionado] = useState('tickets');
  const [tarifaActual, setTarifaActual] = useState(null);
  const { fechasEvento } = useGetFechasEvento(param.id);
  const [ubicaciones, setUbicaciones] = useState([]);
  const [formErrors, setFormErrors] = useState({});
  const [checked, setChecked] = useState(false);
  const [preguntas, setPreguntas] = useState([{
    informacion_adicional: "",
    id_tarifa: 0,
    id_evento: param.id,
  }]);

  const initForm = {
    idevento: param.id,
    idmoneda: 1,
    concepto: '',
    precio: 0,
    idtipo: tipoSeleccionado === 'tickets' ? 1 : 2,
    idubicacion: '',
    nueva_ubicacion: true,
    nombre_ubicacion: '',
    limite_persona: 10,
    limite_maximo: 100,
    asumir_comision: false,
    inicio_venta_fecha: "",
    inicio_venta_hora: "",
    fin_venta_fecha: "",
    fin_venta_hora: "",
    privado: false,
    fechas: [],
    informacion_adicional: false,
    preimpreso: false,
  };

  const [formData, setFormData] = useState(initForm);

  useEffect(() => {
    document.title = `Tarifas | PassGo`;
  }, []);

  useEffect(() => {
    const cargarUbicaciones = async () => {
      try {
        const response = await api.locations.getAll(param.id);
        if (response.status === "success") {
          setUbicaciones(response.data.ubicaciones || []);
        }
      } catch (error) {
        console.error("Error al cargar ubicaciones:", error);
      }
    };

    cargarUbicaciones();
  }, [param.id]);

  const handleOpenModal = (tipo) => {
    setTipoSeleccionado(tipo);
    setFormData({
      ...initForm,
      idtipo: tipo === 'tickets' ? 1 : 2
    });
    setFormErrors({});
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    setFormErrors({});
    setTarifaActual(null);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "limite_persona" || name === "precio" || name === "limite_maximo") {
      if (/^\d*\.?\d*$/.test(value)) {
        setFormData({
          ...formData,
          [name]: value,
        });
      }
    }
    else if (name === "fechas") {
      setFormData({
        ...formData,
        [name]: [...new Set(value)],
      });
    }
    else {
      setFormData({
        ...formData,
        [name]: value,
      });
    }

    if (name !== "fechas" && typeof value === "string" && value.trim() !== "") {
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        [name]: false,
      }));
    }
  };

  const handleChangeVisivilidad = (event) => {
    const { name, value } = event.target;
    setFormData({
      ...formData,
      [name]: value === "true",
    });
  };

  //cambios del checbox de comision
  const handleCheckboxChange = (e) => {
    const { checked } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      asumir_comision: checked
    }));
  };

  //cambios del checkbox de info adicional
  const handleCheckboxChange2 = (event) => {
    const isChecked = event.target.checked;
    setChecked(isChecked);
    setFormData((prevData) => ({
      ...prevData,
      informacion_adicional: isChecked,
    }));

    if (isChecked && preguntas.length === 0) {
      setPreguntas([{ id_tarifa: 0, id_evento: param.id, informacion_adicional: "" }]);
    } else if (!isChecked) {
      setPreguntas(preguntas.map(pregunta => ({
        ...pregunta,
        informacion_adicional: "",
      })));
    }
  };

  //cambios del checkbox de preimpreso
  const handleCheckboxChange3 = (event) => {
    const { checked } = event.target;
    setFormData((prevData) => ({
      ...prevData,
      preimpreso: checked
    }));
  };

  const agregarPregunta = () => {
    setPreguntas([
      ...preguntas,
      { id_tarifa: 0, id_evento: param.id, informacion_adicional: "" }
    ]);
  };

  const handlePreguntaChange = (index, value) => {
    if (preguntas.length === 0) return;

    const nuevasPreguntas = [...preguntas];
    if (index >= 0 && index < nuevasPreguntas.length) {
      nuevasPreguntas[index].informacion_adicional = value;
      setPreguntas(nuevasPreguntas);
    }
  };

  const eliminarPregunta = (index) => {
    if (preguntas.length > 1) {
      setPreguntas(preguntas.filter((_, i) => i !== index));
    }
  };

  const handleGuardarPreguntas = async (tarifaId) => {
    const preguntasFiltradas = preguntas.filter(pregunta => pregunta.informacion_adicional.trim() !== "");

    if (preguntasFiltradas.length === 0) return;

    const dataToSend = preguntasFiltradas.map(pregunta => ({
      id_tarifa: tarifaId,
      id_evento: param.id,
      informacion_adicional: pregunta.informacion_adicional
    }));

    try {
      const response = await api.infoAdicional.createPreguntas(param.id, dataToSend);

      if (response.status !== "success") {
        throw new Error(response.message);
      }

      setChecked(false);
      setPreguntas([]);

      toast.success("Preguntas guardadas correctamente.", {
        position: "top-right",
        autoClose: 2000,
      });
    } catch (error) {
      toast.error(error.message, {
        position: "top-right",
        autoClose: 4000,
      });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.privado) {
      if (!formData.inicio_venta_fecha || !formData.inicio_venta_hora || !formData.fin_venta_fecha || !formData.fin_venta_hora) {
        toast.error("Las fechas de inicio y fin de venta son obligatorias para tarifas públicas.", {
          position: "top-right",
          autoClose: 4000,
        });
        return;
      }
    }

    let inicioVenta = null;
    let finVenta = null;
    if (!formData.privado) {
      try {
        inicioVenta = new Date(`${formData.inicio_venta_fecha}T${formData.inicio_venta_hora}`);
        finVenta = new Date(`${formData.fin_venta_fecha}T${formData.fin_venta_hora}`);

        if (inicioVenta >= finVenta) {
          toast.error("La fecha de inicio de venta debe ser anterior a la fecha de fin de venta.", {
            position: "top-right",
            autoClose: 4000,
          });
          return;
        }
      } catch (error) {
        toast.error("Formato de fecha inválido. Por favor, verifica las fechas.", {
          position: "top-right",
          autoClose: 4000,
        });
        return;
      }
    }

    const errors = {
      concepto: formData.concepto === '',
      ...(tipoSeleccionado === 'tickets' && {
        nombre_ubicacion: formData.nueva_ubicacion && formData.nombre_ubicacion === '',
        idubicacion: !formData.nueva_ubicacion && !formData.idubicacion,
        limite_persona: formData.nueva_ubicacion && formData.limite_persona === '',
        limite_maximo: formData.nueva_ubicacion && formData.limite_maximo === '',
      }),
      ...(tipoSeleccionado === 'consumicion' && {
        limite_persona: formData.limite_persona === '',
        limite_maximo: formData.limite_maximo === '',
      }),
      fechas: formData.fechas?.length === 0,
    };
    setFormErrors(errors);

    const isValid = Object.values(errors).every(error => !error);

    if (isValid) {
      try {
        let idUbicacion = formData.idubicacion;

        // si la ubi es nueva, la creamos primero
        if (tipoSeleccionado === 'tickets' && formData.nueva_ubicacion) {
          // si existe alguna ubi con el mismo nombre en el mismo evento, se reusa el id
          const ubicacionExistente = ubicaciones.find(
            u => u.ubicacion.toLowerCase() === formData.nombre_ubicacion.toLowerCase()
          );

          if (ubicacionExistente) {
            idUbicacion = ubicacionExistente.id;
          } else {
            const nuevaUbicacion = {
              idevento: parseInt(param.id),
              ubicacion: formData.nombre_ubicacion,
              limitepersona: parseInt(formData.limite_persona),
              limitemaximo: parseInt(formData.limite_maximo),
            };

            try {
              const respUbicacion = await api.locations.createLocation(nuevaUbicacion);

              if (respUbicacion.status !== "success") {
                throw new Error(respUbicacion.message || "Error al crear la ubicación");
              }

              idUbicacion = respUbicacion.data.ubicacion.id;

              setUbicaciones(prevUbicaciones => [...prevUbicaciones, respUbicacion.data.ubicacion]);
            } catch (error) {
              console.error("Error al crear ubicación:", error);
              throw new Error(`Error al crear la ubicación: ${error.message}`);
            }
          }
        }

        const tarifaData = {
          ...formData,
          idevento: parseInt(param.id),
          precio: parseFloat(formData.precio),
          idtipo: parseInt(formData.idtipo),
          idubicacion: tipoSeleccionado === 'tickets' ? parseInt(idUbicacion || 0) : 0,
          limite_persona: parseInt(formData.limite_persona || 0),
          limite_maximo: parseInt(formData.limite_maximo || 0),
          fechas: formData.fechas?.map(fechaId => ({ id: fechaId })),
          ...(inicioVenta && { inicio_venta: inicioVenta.toISOString() }),
          ...(finVenta && { fin_venta: finVenta.toISOString() }),
          informacion_adicional: formData.informacion_adicional,
        };

        const response = await api.tarifas.createTarifa(tarifaData);

        if (response.status === "success") {
          const tarifaId = response.data?.tarifa.id;

          if (tarifaId && formData.informacion_adicional && preguntas.length > 0 &&
            !preguntas.some(pregunta => pregunta.informacion_adicional?.trim() === "")) {
            await handleGuardarPreguntas(tarifaId);
          }

          setModalOpen(false);
          setFormData(initForm);
          setTarifaActual(null);
          setPreguntas([{
            informacion_adicional: "",
            id_tarifa: 0,
            id_evento: param.id,
          }]);

          toast.success("Tarifa creada correctamente.", {
            position: "top-right",
            autoClose: 2000,
          });

          window.location.reload();
        } else {
          throw new Error(response.message || "Error al procesar la tarifa");
        }
      } catch (error) {
        toast.error(error.message, {
          position: "top-right",
          autoClose: 4000,
        });
      }
    } else {
      toast.error("Por favor, completa todos los campos obligatorios.", {
        position: "top-right",
        autoClose: 4000,
      });
    }
  };

  return (
    <Container>
      <Box sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        mb: 3,
        mt: 3
      }}>
        <Typography variant="h5" component="h4">Para tickets</Typography>
        <Button
          sx={{
            backgroundColor: "#FFC300",
            color: "black",
            outline: "none",
            borderRadius: "5px",
            textTransform: "none",
            fontFamily: 'Inter, sans-serif',
            padding: "5px 10px",
            '&:hover': {
              backgroundColor: "#FFB000",
            }
          }}
          startIcon={<AddIcon />}
          onClick={() => handleOpenModal('tickets')}
        >
          Agregar ticket
        </Button>
      </Box>
      <EventoTickets />

      <Box sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        mb: 2,
        mt: 4
      }}>
        <Typography variant="h5" component="h4">Para vouchers</Typography>
        <Button
          sx={{
            backgroundColor: "#FFC300",
            color: "black",
            outline: "none",
            borderRadius: "5px",
            textTransform: "none",
            fontFamily: 'Inter, sans-serif',
            padding: "5px 10px",
            '&:hover': {
              backgroundColor: "#FFB000",
            }
          }}
          startIcon={<AddIcon />}
          onClick={() => handleOpenModal('consumicion')}
        >
          Agregar voucher
        </Button>
      </Box>
      <EventoVouchers />

      <div className="d-flex justify-content-end mt-4">
        <VolverButton />
      </div>

      {/* Modal para crear tarifa */}
      <CreateEditTarifa
        modalOpen={modalOpen}
        handleCloseModal={handleCloseModal}
        tipoSeleccionado={tipoSeleccionado}
        tarifaActual={tarifaActual}
        formData={formData}
        setFormData={setFormData}
        formErrors={formErrors}
        fechasEvento={fechasEvento}
        ubicaciones={ubicaciones}
        preguntas={preguntas}
        setPreguntas={setPreguntas}
        checked={checked}
        handleChange={handleChange}
        handleChangeVisivilidad={handleChangeVisivilidad}
        handleCheckboxChange={handleCheckboxChange}
        handleCheckboxChange2={handleCheckboxChange2}
        handleCheckboxChange3={handleCheckboxChange3}
        handlePreguntaChange={handlePreguntaChange}
        agregarPregunta={agregarPregunta}
        eliminarPregunta={eliminarPregunta}
        handleSubmit={handleSubmit}
      />
    </Container>
  );
};

export default withAuthenticationRequired(Tarifas, {
  onRedirecting: () => <Loading />,
});